import axios from "axios";

const axiosAdmin = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/admin`,
});

axiosAdmin.interceptors.request.use((config) => {
  const token = localStorage.getItem("MGL_TOKEN_ADM");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosAdmin.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    if (response?.status === 401) {
      localStorage.removeItem("MGL_TOKEN_ADM");
      // window.location.reload();
    } else if (response?.status === 404) {
      //Show not found
    }

    throw error;
  }
);

export default axiosAdmin;
